<template>
  <div v-if="messageType">{{ message }}</div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('Message', {
    props: {
      message: String,
      messageType: String, // error|success
    }
  });
</script>